import { createSlice } from '@reduxjs/toolkit'
import { actions as clientActions } from '@gocanvas/client'
const { loadFormData } = clientActions

export const conditionTypesSlice = createSlice({
  name: 'conditionTypes',
  initialState: [],
  reducers: {},
  extraReducers: builder => {
    builder.addCase(loadFormData, (_, action) => {
      const { conditionTypes } = action.payload
      return conditionTypes
    })
  },
})

const { actions, reducer } = conditionTypesSlice
export const conditionTypesActions = actions
export const conditionTypesReducer = reducer
